var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import { Select } from '@emburse/ui-core';
export const ParentCardSelect = (_a) => {
    var { parentCards } = _a, rest = __rest(_a, ["parentCards"]);
    return (_jsxs(Select, Object.assign({ fullWidth: true, required: true, label: "Parent Card", native: true, id: "parent-card-select", name: "parent-card-select", disabled: true }, rest, { children: [_jsx("option", { "aria-label": "none", value: "" }), parentCards.map((card) => (_jsx("option", Object.assign({ value: card.id }, { children: card.displayName }), card.id)))] })));
};
